<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'수령 정보 입력'"
      :modal="true"
      :width="'500px'"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="w100">
      <ul class="filter_list">
        <li>
          <dd class="w100">
            <label class="w30">
              수령인
              <span class="forg">*</span>
            </label>
            <ul class="w70">
              <li>
                <input
                      class="k-textbox w95"
                      :class="{'error' : errorTarget === 'userNm'}"
                      placeholder="대리 수령인 이름을 입력하세요."
                      v-model = "senderData.userNm"
                      @input="senderData.userNm=EtnersCommonUtil.cutByteLength(senderData.userNm, 100)"
                      @keyup.enter = "onClickSave"
                >
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd class="w100">
            <label class="w30">
              수령인부서
              <span class="forg">*</span>
            </label>
             <ul class="w70">
              <li>
              <input
                 class="k-textbox w95"
                 :class="{'error' : errorTarget === 'receiveDept'}"
                 placeholder="대리 수령인 부서를 입력하세요."
                 maxlength="50"
                 v-model = "senderData.receiveDept"
                 @keyup.enter = "onClickSave"
              >
              </li>
             </ul>
          </dd>
        </li>
        <li>
          <dd class="w100">
            <label class="w30">
            용도
            <span class="forg">*</span>
          </label>
          <ul class="w70">
            <li>
            <div class="w50 f_l" v-for="item in ppsScnList ">
              <input
                  class="k-radio"
                  type="radio"
                  v-model="senderData.ppsScn"
                  :id="`${item.cdId}_ppsScn`"
                  :value="item.cdId"
              >
              <label :for="`${item.cdId}_ppsScn`" class="k-radio-label w100" >{{ item.cdNm }} </label>
            </div>
            </li>
          </ul>
          </dd>
        </li>
        <li>
          <dd class="w100">
            <label class="w30">
              반입 목적
              <span class="forg">*</span>
            </label>
             <ul class="w70">
              <li>
                <div class="f_l w50" v-for="item in receivePurposeList ">
                  <input
                      class="k-radio"
                      type="radio"
                      v-model="senderData.receivePurpose"
                      :id="`${item.cdId}_receivePurpose`"
                      :value="item.cdId"
                  >
                  <label :for="`${item.cdId}_receivePurpose`" class="k-radio-label w100">{{ item.cdNm }} </label>
                </div>
                <div v-show="senderData.receivePurpose === '03'" >
                <input
                      class="k-textbox w100"
                      :class="{'error' : errorTarget === 'receivePurposeDesc'}"
                      placeholder="기타"
                      maxlength="100"
                      v-model.trim = "senderData.receivePurposeDesc"
                      @keyup.enter = "onClickSave"
                >
                </div>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <div class="button_area w50">
      <ul>
        <li class="w40">
          <button class="large_btn orange" @click="onClickSave">등록</button>
        </li>
        <li class="w40">
          <button class="large_btn" @click="onClickCancel">취소</button>
        </li>
      </ul>
    </div>
  </kendo-window>
</template>

<script>
import { LogisticsCodeDtlMixin } from '@/mixin/Mixin'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "CreateSteadReceiveInterDocu",
  mixins: [LogisticsCodeDtlMixin],
  methods: {
    validation(){
      const vm = this
      const senderData = vm.senderData
      // 필수값 체크
      if (EtnersCommonUtil.isEmpty(senderData.userNm)) {
        kendo.alert('대리 수령인 이름을 입력하세요')
        vm.errorTarget = 'userNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(senderData.receiveDept)) {
        kendo.alert('대리 수령인 부서를 입력하세요')
        vm.errorTarget = 'receiveDept'
        return
      }
      if (EtnersCommonUtil.isEmpty(senderData.ppsScn)) {
        kendo.alert('용도를 선택하세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(senderData.receivePurpose)) {
        kendo.alert('반입 목적을 선택하세요')
        vm.errorTarget = 'receivePurpose'
        return
      }
      if (senderData.receivePurpose === '03' && EtnersCommonUtil.isEmpty(senderData.receivePurposeDesc)) {
        kendo.alert('기타 반입 목적을 입력하세요')
        vm.errorTarget = 'receivePurposeDesc'
        return
      }
      vm.errorTarget = null
      return true
    },
    async onClickSave(){
      const vm = this
      if (vm.validation()) {
        vm.steadRecieve()
      }
    },
    steadRecieve() {
      const vm = this
      const refs = this.$refs
      const data = {
        receiveNm: vm.senderData.userNm,
        receiveDept: vm.senderData.receiveDept,
        receivePpsScn: vm.senderData.ppsScn,
        receivePurpose: vm.senderData.receivePurpose,
        receivePurposeDesc: vm.senderData.receivePurposeDesc,
      }

      refs.kendoWindowRef.kendoWidget().close()
      vm.$emit('getUserData', data)
    },
    onClickCancel() {
      const refs = this.$refs
      refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data() {
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      receiveId: this.$route.params.receiveId,
      userDataSource: [],
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      senderData: {
        userNm: null,
        receiveDept: null,
        ppsScn: null,
        receivePurpose: null,
        receivePurposeDesc: null,
      },
      errorTarget : null,
    }
  }
}
</script>

<style scoped>

</style>
